import Model from '@/models/Model.js';

export default class LocationType extends Model {
    static entity = 'location_types';

    static modelName = 'LocationType';

    static fields() {
        return {
            id: this.attr(null),
            default_attendance_scenario_id: this.attr(null),
            external_id: this.attr(null),
            name: this.attr(null),
            description: this.attr(null),
            coursekey_attendance_name: this.attr(null),

            ...super.fields(),

            defaultAttendanceScenario: this.belongsTo('attendance_scenarios', 'default_attendance_scenario_id'),
        };
    }
}
